module.exports = __webpack_public_path__ + "static/media/p6.70bec895.webp";